/*jshint esversion: 6 */
require('../main.js');

export class WebModal{
	constructor(AppWeb = null, settings = {}){
		this.AppWeb = AppWeb;
		this.opened = false;
		this.settings = settings;
		this.size = {
			width: 0,
			height: 0
		};
		this.config = {
			width: 0,
			height: 0
		};
		this.customSettings = {};
	}

	open(url){
		let that = this;
		let _modal = $(this.settings.id);

		_modal.css({height: $(window).height(), top: $(document).scrollTop()});

		var content = _modal.find(".modal-content");
		content.css({top: parseInt(that.settings.top)});

		_modal.fadeIn("fast");

		_modal.find(".modal-content").load(url, function(){
			if(that.AppWeb.blocked) return false;

			that.AppWeb.blocked = true;

			let inner_content = content.find("[role=modal-main]");

			if(inner_content.length === 0){
				content.html("<section role='modal-main'>"+content.html()+"</section>");
				inner_content = content.find("[role=modal-main]");
			}

			that.config.width  = inner_content.data("width") !== undefined ? inner_content.data("width") : "auto";
			that.config.height = inner_content.data("height") !== undefined ? inner_content.data("height") : "auto";

			if(that.settings.closeButton){
				content.append(that.settings.closeButton);
			}

			inner_content.width(that.config.width);
			inner_content.height(that.config.height);

			$('html').css({'overflow-y':'hidden'});
			that.opened = true;
			that.size.width = inner_content.outerWidth();
			that.size.height = inner_content.outerHeight();

			/* Events */
			$(window).on("resize.modal",function(){
				that.resize(that);
			});
			$(window).on("keydown.modal",function(e){
				if(e.which == 27)
				that.close();
			});

			_modal.unbind("click");
			_modal.on("click",function(e){
				that.close();
			});

			content.on("click", function(e){
				e.stopPropagation();
			});

			that.bindClose(that.settings.selectors.close);
			that.fitContent();

			if(that.customSettings.onComplete){
				if($.type(that.customSettings.onComplete) == "function"){
					that.customSettings.onComplete();
				}
				else{
					that._runFuncByName(that.customSettings.onComplete, window);
				}
			}

			that.AppWeb.blocked = false;
			that.AppWeb.bindAll(_modal);

			$(inner_content).find('input:first').focus();
		});
	}

	calculate(inner_content){
		let that = this;
		let dim = {width:"auto", height:"auto"};

		// Width
		if(inner_content.outerWidth() > $(window).width()){
			dim.width = $(window).width() - 20;
		}
		else{
			if($(window).width() >= inner_content.outerWidth()){
				if(that.size.width > $(window).width()){
					dim.width = $(window).width() - 20;
				}
				else{
					if(that.config.width !== "auto")
					dim.width = that.size.width - 20;
				}
			}
		}
		return(dim);
	}

	fitContent(){
		if(this.opened){
			this.resize(this);
		}
	}

	resize(modal){
		let that = this;
		let _modal = $(that.settings.id);
		let content = _modal.find(".modal-content");
		let inner_content = content.find("[role=modal-main]");
		let _top = 0;

		_top += that.settings.top !== undefined ? parseInt(that.settings.top) : 0;
		let dim = that.calculate(inner_content);

		_modal.css({height : $(window).height(), top: $(document).scrollTop()});
		$(content).css({top: _top});

		$(content).css({width: dim.width, height: dim.height});
		$(inner_content).css({width: dim.width, height: dim.height});
	}

	bindOpen(selector, url){
		let that = this;

		$(selector).unbind("click");
		$(selector).on("click", function(e){
			e.preventDefault();
			that.customSettings = {
				closeButton : $(this).data("closebut"),
				loader : $(this).attr('loader') || false,
				transition : $(this).data("transition") || null,
				onComplete : $(this).attr("on-complete") || null,
				onClose : $(this).attr("on-close") || null
			};

			if(that.AppWeb.settings.loader){
				$(this).append(that.AppWeb.settings.loader.html);
			}

			that.open(url !== undefined ? url : $(this).attr("href"), $(this));
		});
	}

	close(){
		$(window).off("resize.modal");
		$(window).off("scroll.modal");
		$(window).off("keydown.modal");

		$(this.settings.id).fadeOut("fast");
		$(this.settings.id).find(".modal-content").html("");

		$('html').css({'overflow-y': ''});

		if(this.customSettings.onClose){
			if($.type(this.customSettings.onClose) == "function"){
				this.customSettings.onClose();
			}
			else{
				this.AppWeb._runFuncByName(this.customSettings.onClose, window);
			}
		}
		this.opened = false;
		this.customSettings = {};
	}

	bindClose(selector){
		$(selector).unbind("click");
		$(selector).on("click", () => {
			this.close();
		});
	}

	bindAll(context){
		this.bindOpen($(context).find(this.settings.selectors.open));
	}
}

module.exports = WebModal;



// WEBPACK FOOTER //
// ./C:/wamp64/www/cig-landing/devel/js/modules/modal.js